export enum FeedType {
  Categories = 'categories',
  Posts = 'all-posts',
  MyPosts = 'my-posts',
}
